import React from 'react';
import { Snackbar, SnackbarContent, IconButton, Avatar } from '@material-ui/core';
import { CloseOutlined } from '@material-ui/icons';

import './css/Notifications.css';
import {RootStoreContext} from '../../context';
class LastNotificationPreview extends React.Component {
  static contextType = RootStoreContext;
  componentDidMount () {
    this.notify();
  }

  componentDidUpdate () {
    this.notify();
  }

  notify () {
    const { desktopNotifications, notification } = this.props;
    if (notification.type === 'anchorStartingBroadcast') {
      if (desktopNotifications) {
        const n = new Notification(
          'Anchor is live',
          { body: `${notification.anchorName} has started a live broadcast!` }
        );
        n.onclick = this.onNotificationClick;
      }
    }
  }

  onNotificationClick = event => {
    const { notification } = this.props;
    event.preventDefault();
    window.location.href = `${window.location.origin}${notification.anchorPath}`
  }

  render () {
    const { notification, dismiss } = this.props;
    let message = '';
    let snackbarContentMessage; 
    let snackbarContentMessageText;
    let anchorPageURL = `/naked-news-anchor-a${notification?.anchorId}`;
    if (parseInt(notification.anchorId, 10) === 241) {
      anchorPageURL = '/live';
    }
    if (notification.type === 'anchorStartingBroadcast' && !notification.isPublic) {
      message = `${notification.anchorName} has started a live broadcast`;
      snackbarContentMessageText = (
        <a href={anchorPageURL} id="global-notification-message">{message}!</a>
      );
    }
    if (notification.type === 'anchorStartingBroadcast' && notification.isPublic){
      message = `${notification.anchorName} has just started a FREE live show`;
      snackbarContentMessageText = (
        <a href={anchorPageURL} id="global-notification-message">{message}!</a>
      );
    }
    if (notification.type === 'temptationStartedSpotlighting'){
      message = `${notification.temptationName} has started spotlighting ${notification.spotlightedTemptationName}! Watch now!`;
      if (notification.anchorId === 241 || notification.temptationId === 241) {
        snackbarContentMessageText = (
          <a href={`/live`} id="global-notification-message">{message}</a>
        );
      } else {
        snackbarContentMessageText = (
          <a href={`/naked-news-anchor-a${notification.anchorId || notification.temptationId}`} id="global-notification-message">{message}</a>
        );
      }
    }
    if (notification.type === 'temptationStoppedSpotlighting'){
      return null;
    }
    if (notification.type === 'anchorStoppingBroadcast') {
      message = `Do you want to thank ${notification.anchorName} for her live show`;
      snackbarContentMessageText = (
        <span id="global-notification-message">{message} <button className="send-tip-button" onClick={()=>{this.context.tippingStore.setTippingModal({name: notification.anchorName, id: notification.anchorId })}}> Send tip </button>!</span>
      );
    }
    if (notification.type === 'temptationJoinedVPS'){
      let partyShowInitiator = (notification.initiatorTemptationName ? notification.initiatorTemptationName : notification.initiatorTemptationNickname)
      let anchorName = (notification.temptationNickname ? notification.temptationNickname : notification.temptationName)
      message = `${anchorName} has just joined ${partyShowInitiator}'s Live show`;
      snackbarContentMessageText = (
        <a href={`/naked-news-anchor-a${notification.temptationId}`} id="global-notification-message">{message}!</a>
      );
    }
    if (notification.anchorNotificationImage || notification.temptationNotificationImage) {
      snackbarContentMessage = (
        <div id="global-notification-with-image-container">
          <Avatar src={notification.anchorNotificationImage ? notification.anchorNotificationImage : notification.temptationNotificationImage} style={{ marginRight: '10px' }} />
          {snackbarContentMessageText}
        </div>
      );
    } else {
      snackbarContentMessage = snackbarContentMessageText;
    }
    return (
      <Snackbar
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left'
        }}
        open={true}>
        <SnackbarContent
          style={{ backgroundColor: '#0064E5' }}
          message={snackbarContentMessage}
          action={[
            <IconButton color="inherit" key="close" onClick={dismiss}>
              <CloseOutlined fontSize="large" />
            </IconButton>
          ]}
        />
      </Snackbar>
    );
  }
}

export default LastNotificationPreview;